import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { iconTooltipDriverFactory } from './IconTooltip.driver';
import { IconTooltip, IconTooltipProps } from '.';
import { Error } from '@wix/wix-ui-icons-common/on-stage';
import { waitFor } from '@testing-library/react';

describe('IconTooltip', () => {
  const errorMessage = 'The data you’ve entered is invalid';
  const createDriver = createRendererWithUniDriver(iconTooltipDriverFactory);

  const bootstrap = (props: Partial<IconTooltipProps> = {}) => {
    return createDriver(
      <IconTooltip message={errorMessage} icon={<Error />} {...props} />,
    );
  };

  it('should render', async () => {
    const { driver } = bootstrap();
    expect(await driver.exists()).toBe(true);
  });

  it('should return a unique tooltip id each time', async () => {
    const { driver: driver1 } = bootstrap();
    const { driver: driver2 } = bootstrap();

    const id1 = await driver1.getTooltipId();
    const id2 = await driver2.getTooltipId();

    expect(id1).not.toEqual(id2);
  });

  it('should call onClick when button is clicked', async () => {
    const onClick = jest.fn();
    const { driver } = bootstrap({ onClick });

    expect(onClick).toBeCalledTimes(0);

    await driver.click();

    expect(onClick).toBeCalledTimes(1);
  });

  it('should tooltip not be open by default', async () => {
    const { driver } = bootstrap();

    const iconButtonDescription = driver.getIconButtonDescription();
    expect(await iconButtonDescription.text()).toBe(errorMessage);
    const tooltipContent = driver.getTooltipContent();
    expect(await tooltipContent.exists()).toBe(false);
  });

  it('should tooltip be open when showTooltip=true', async () => {
    const { driver } = bootstrap({ showTooltip: true });
    await waitFor(async () => expect(await driver.tooltipExists()).toBe(true));

    const iconButtonDescription = driver.getIconButtonDescription();
    expect(await iconButtonDescription.exists()).toBe(false);
    const tooltipContent = driver.getTooltipContent();
    expect(await tooltipContent.text()).toBe(errorMessage);
  });

  it('should call onEscape when Escape key is pressed', async () => {
    const onEscape = jest.fn();
    const { driver } = bootstrap({ onEscape, showTooltip: true });
    await waitFor(async () => expect(await driver.tooltipExists()).toBe(true));

    expect(onEscape).toBeCalledTimes(0);

    await driver.pressKey('Escape');

    expect(onEscape).toBeCalledTimes(1);
  });
});
